var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"landing-subtitle",class:{ 'landing-subtitle_uppercase': _vm.uppercase },attrs:{"data-typo-type":"subtitle"},domProps:{"innerHTML":_vm._s(_vm.title)}})
}
var staticRenderFns = []

export { render, staticRenderFns }